import React from 'react'
import { Switch, Route, RouteComponentProps } from 'react-router'

import { EditContainer } from './Edit'
import { PLANS_URL, plansEdit, PLANS_CREATE_URL } from '../../../constants/urls/frontend'
import { CreateContainer } from './Create'
import { DisplayContainer } from './Display'

const PlansPage: React.FC<RouteComponentProps> = (): JSX.Element => {
  return (
    <Switch>
      <Route path={plansEdit()} component={EditContainer} />
      <Route path={PLANS_CREATE_URL} component={CreateContainer} />
      <Route path={PLANS_URL} component={DisplayContainer} />
    </Switch>
  )
}

export {
  PlansPage
}
